import Button from "../../components/button";
import Modal from "../../components/modal";
import Headline6 from "../../components/headings/Headline6";



const  ConfirmationModal = (props:any) => {

    const Submit = () => {
      props.submit()
      props.onClose()
    }
 
    return (
      <Modal title="Availability" size="xsmall" onClose={props.onClose}>
          <div className="form-group">
          <Headline6>{props.logout ? 'Are you sure you want to log out?' : 'Are you sure to Continue?'}</Headline6>
          </div>
          <div className="popupAction">
            <Button variant='secondary'  onClick={props.onClose}>Cancel</Button>
            <Button variant='primary' onClick={Submit} >{props.logout ? 'Yes' : 'Continue'}</Button>
          </div>
        </Modal>
    )
}
export default  ConfirmationModal